import AboutService from '@/services/about'

export default {
  index ({commit}, options = {}) {
    return new Promise((resolve, reject) => {
      AboutService.getData(options)
        .then(response => {
          commit('SET_DATA', response.data.data)
          resolve()
        })
        .catch(e => reject(e))
    })
  }
}